import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "./AdminAuthContext";
import { formatApiErrorDetail } from "./api";
import Logo from "@/components/site/Logo";

export default function Login() {
  const { login } = useAdminAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const res = await login(email.trim(), password);
      if (res.must_change_password) nav("/admin/change-password", { replace: true });
      else nav("/admin", { replace: true });
    } catch (e2) {
      setErr(formatApiErrorDetail(e2.response?.data?.detail) || "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ga-auth" data-testid="admin-login-page">
      <div className="ga-auth__logo" data-testid="admin-login-logo">
        <Logo variant="full" theme="gold" asLink={false} />
      </div>
      <div className="ga-auth__card">
        <div className="ga-eyebrow">Gold Petroleum · Admin</div>
        <h1 className="ga-auth__title">Sign in</h1>
        <p className="ga-auth__sub">Authorised users only.</p>
        <form onSubmit={onSubmit} className="ga-form" noValidate>
          <label className="ga-field">
            <span>Email</span>
            <input
              name="email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
            />
          </label>
          <label className="ga-field">
            <span>Password</span>
            <input
              name="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
            />
          </label>
          {err && <div className="ga-error" data-testid="login-error">{err}</div>}
          <button type="submit" className="ga-btn" disabled={busy} data-testid="login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
